module.exports = __webpack_public_path__ + "img/6.41e282db.png";